import { render, staticRenderFns } from "./UserDrawer.vue?vue&type=template&id=6f4ac716&scoped=true&"
import script from "./UserDrawer.vue?vue&type=script&lang=js&"
export * from "./UserDrawer.vue?vue&type=script&lang=js&"
import style0 from "./UserDrawer.vue?vue&type=style&index=0&id=6f4ac716&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4ac716",
  null
  
)

export default component.exports